import { useEntryTemplate } from "./useEntryTemplate"

export function useEntryTemplateTitle(id: string): string {
  const entryTemplate = useEntryTemplate(id)
  return entryTemplate?.title ?? "\u200B"
}
